import React, { Component } from 'react';

import { connect } from 'react-redux';

import { Button } from 'react-bootstrap';

import translate from '../localization/translator';

import { logout } from '../../modules/login/login.actions';
import security from '../common/security/security';

import './logout.css';

class Logout extends Component {

	isVisible() {
		return security.isAuthorized();
	}
	render() {
		if (this.isVisible()) {
			return (
				<Button
					bsStyle={'default'}
					bsSize={'xsmall'}
					onClick={() => {
						this.props.logout(()=>{
							this.props.history.push('/login');
						});
					}}>
					<span>{translate.translate("_logout_")}</span>
					<span className="glyphicon glyphicon-off logout-off"></span>
				</Button>
			);
		}
		return null;
	}
};

let mapStateToProps = (state) => {
	return {
		login: state.login
	};
};

export default connect(mapStateToProps, {
	logout
})(Logout);